(() => {
  'use strict';

  const BOOSTER_FROM = 'auto50ml';
  const BOOSTER_VARIANTS = {
    '3mg': 54510280802645,
    '6mg': 54510280835413
  };
  const nativeFetch = window.fetch.bind(window);
  const shopRoot = window.Shopify?.routes?.root || '/';
  let syncing = false;
  let pending = false;
  let timer;

  const route = (path) => `${shopRoot.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
  const normalizeMode = (value) => value === '3mg' || value === '6mg' ? value : null;
  const unitsForMode = (mode) => mode === '6mg' ? 2 : 1;
  const propertiesOf = (item) => item.properties || {};
  const isAutoBooster = (item) => propertiesOf(item)._booster_from === BOOSTER_FROM;
  const choiceOf = (item) => normalizeMode(propertiesOf(item)._booster_choice);
  const linkedVariantOf = (item) => Math.max(0, Number(propertiesOf(item)._booster_variant) || 0);
  const isCartPage = () => {
    const current = window.location.pathname.replace(/\/+$/, '');
    const cartPath = new URL(route('cart'), window.location.origin).pathname.replace(/\/+$/, '');
    return current === cartPath;
  };

  async function request(path, options = {}) {
    const requestOptions = {
      ...options,
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...(options.headers || {})
      }
    };
    const response = await nativeFetch(route(path), requestOptions);
    if (!response.ok) throw new Error(`${path} failed (${response.status})`);
    return response.json();
  }

  const fetchCart = () => request('cart.js');
  const changeLine = (key, quantity) => request('cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  });
  const addBooster = (mode, quantity, linkedVariant) => request('cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: linkedVariant || BOOSTER_VARIANTS[mode],
        quantity,
        properties: {
          _ajout_automatique: 'Booster 50 ml',
          _booster_from: BOOSTER_FROM,
          _booster_choice: mode,
          _booster_unit: String(unitsForMode(mode)),
          _dosage_choisi: mode.replace('mg', ' mg')
        }
      }]
    })
  });

  async function syncBoostersNow() {
    if (syncing) {
      pending = true;
      return;
    }
    syncing = true;
    let changed = false;

    try {
      const cart = await fetchCart();
      const bottlesByMode = new Map();
      const boostersByMode = new Map();

      for (const item of cart.items || []) {
        const mode = choiceOf(item);
        if (!mode) continue;

        if (isAutoBooster(item)) {
          if (!boostersByMode.has(mode)) boostersByMode.set(mode, []);
          boostersByMode.get(mode).push(item);
        } else {
          const linked = bottlesByMode.get(mode) || { quantity: 0, variantId: 0 };
          linked.quantity += Number(item.quantity || 0);
          linked.variantId ||= linkedVariantOf(item);
          bottlesByMode.set(mode, linked);
        }
      }

      for (const [mode, bottle] of bottlesByMode) {
        const desired = bottle.quantity * unitsForMode(mode);
        const lines = boostersByMode.get(mode) || [];

        if (!lines.length && desired > 0) {
          await addBooster(mode, desired, bottle.variantId);
          changed = true;
          continue;
        }

        const [keeper, ...duplicates] = lines;
        if (keeper && Number(keeper.quantity) !== desired) {
          await changeLine(keeper.key, desired);
          changed = true;
        }
        for (const duplicate of duplicates) {
          await changeLine(duplicate.key, 0);
          changed = true;
        }
      }

      for (const [mode, lines] of boostersByMode) {
        if (bottlesByMode.has(mode)) continue;
        for (const item of lines) {
          await changeLine(item.key, 0);
          changed = true;
        }
      }

      if (changed) {
        if (isCartPage()) {
          window.location.reload();
          return;
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } catch (error) {
      console.warn('[ClassClope BoosterGuard]', error);
    } finally {
      syncing = false;
      if (pending) {
        pending = false;
        schedule(120);
      }
    }
  }

  function schedule(delay = 280) {
    window.clearTimeout(timer);
    timer = window.setTimeout(syncBoostersNow, delay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => schedule(350), { once: true });
  } else {
    schedule(350);
  }

  document.addEventListener('change', (event) => {
    if (event.target?.matches('input[name="updates[]"], input.quantity__input')) schedule(420);
  });
  document.addEventListener('click', (event) => {
    if (event.target?.closest('quantity-input button, cart-remove-button, .quantity__button')) schedule(500);
  });

  window.fetch = function (...args) {
    const url = String(args?.[0]?.url || args?.[0] || '');
    const promise = nativeFetch(...args);
    if (/\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(url)) {
      promise.then(() => schedule(320)).catch(() => {});
    }
    return promise;
  };
})();
